const slotItems = [
  'prize_3rd_1',
  'prize_3rd_2',
  'prize_3rd_3',
  'prize_3rd_4',
  'prize_3rd_5',
  'prize_3rd_6',
  'prize_3rd_7',
  'prize_3rd_8',
  //'prize_2nd',
  'prize_1st'
]

export { slotItems }
